export const LEDGER_TYPE_NAME = {

   //Ledger for shop
   CASH_BOOK_SH :   "CASH BOOK SH",
   CA_P_AND_P_SH :   "CA P AND P SH",
   SEYLAN_BANK_SH : "SEYLAN BANK SH",
   DFCC_SH : "DFCC SH",
   HNB_SH : "HNB SH",
   CC_DFCC_SH : "CC DFCC SH",
   CC_HNB_SH : "CC HNB SH",

   LOCKER : "LOCKER",

    //Ledger for stores
   CASH_BOOK_ST :   "CASH BOOK ST",
   CA_P_AND_P_ST :   "CA P AND P ST",
   CA_FAZIL : "CA FAZIL",
   CA_FAHIK : "CA FAHIK",
   CA_FAHJI : "CA FAHJI",
   SEYLAN_BANK_ST : "SEYLAN BANK ST",
   DFCC_ST : "DFCC ST",
   HNB_ST : "HNB ST",
   FAZIL_LOAN : "FAZIL LOAN",
   FAHIK_LOAN : "FAHIK LOAN",
   FAHJI_LOAN : "FAHJI LOAN",

}